/*--------------------------------------------------------------------------------
On Load
--------------------------------------------------------------------------------*/
// jQuery(window).load(function() {
	

// });


/*--------------------------------------------------------------------------------
General Ready
--------------------------------------------------------------------------------*/
( function( $ ) {
$(document).ready(function(){

	/*--------------------------------------------------------------------------------
	Mobile
	--------------------------------------------------------------------------------*/

	$('.mobile-menu-button').click(function(e){
		e.preventDefault();
		$(this).toggleClass('is-active');
		$('html').toggleClass('mobile-menu-open');
	});



	/*--------------------------------------------------------------------------------
	Video Posts
	--------------------------------------------------------------------------------*/

	$('.player-details-button').click(function(e){
		e.preventDefault();
		$(this).hide();
		$('.player-details-lower').css('display', 'block');
	});

	/*--------------------------------------------------------------------------------
	Class Detail Join Button
	--------------------------------------------------------------------------------*/

	$('.location-join').click(function(e){
		e.preventDefault();
		$(this).hide();
		$('.location-contact').addClass('is-active');
	});

	/*--------------------------------------------------------------------------------
	Class Detail Maps
	--------------------------------------------------------------------------------*/

	function initMap( $el ) {
		// Find marker elements within map
		var $markers = $el.find('.marker');

		// Create generic map
		var mapArgs = {
			zoom : $el.data('zoom') || 12,
			mapTypeId : google.maps.MapTypeId.ROADMAP,
			disableDefaultUI: true,
			styles: [
				{
					"featureType": "administrative",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#a7a7a7"
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"visibility": "on"
						},
						{
							"color": "#737373"
						}
					]
				},
				{
					"featureType": "landscape",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"visibility": "on"
						},
						{
							"color": "#eaeaea"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"visibility": "on"
						},
						{
							"color": "#dadada"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "labels",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "road",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#696969"
						}
					]
				},
				{
					"featureType": "road",
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#ffffff"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"visibility": "on"
						},
						{
							"color": "#b3b3b3"
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#ffffff"
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#d6d6d6"
						}
					]
				},
				{
					"featureType": "road.local",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"visibility": "on"
						},
						{
							"color": "#ffffff"
						},
						{
							"weight": 1.8
						}
					]
				},
				{
					"featureType": "road.local",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#d7d7d7"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "all",
					"stylers": [
						{
							"color": "#808080"
						},
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#d3d3d3"
						}
					]
				}
			]
		};
		window.map = new google.maps.Map( $el[0], mapArgs );

		// Add markers
		map.markers = [];
		$markers.each(function(){
			initMarker( $(this), map );
		});

		// Center map based on markers
		centerMap( map );

		// Return map instance
		return map;
	}

	function initMarker( $marker, map ) {
		// Get position from marker
		var lat = $marker.data('lat');
		var lng = $marker.data('lng');
		var latLng = {
			lat: parseFloat( lat ),
			lng: parseFloat( lng )
		};

		var icon = {
			url: main_vars.theme_url + '/images/icon-pin.png',
			size: new google.maps.Size(72, 72),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(36, 72),
		}

		// Create marker instance
		var marker = new google.maps.Marker({
			position : latLng,
			map: map,
			icon: icon
		});

		// Append to reference for later use
		map.markers.push( marker );

		// If marker contains HTML, add it to an infoWindow
		if( $marker.html() ){

			// Create info window
			var infowindow = new google.maps.InfoWindow({
				content: $marker.html()
			});

			// Show info window when marker is clicked
			google.maps.event.addListener(marker, 'click', function() {
				infowindow.open( map, marker );
			});
		}
	}

	function centerMap( map ) {
		// Create map boundaries from all map markers.
		var bounds = new google.maps.LatLngBounds();
		map.markers.forEach(function( marker ){
			bounds.extend({
				lat: marker.position.lat(),
				lng: marker.position.lng()
			});
		});

		// Case: Single marker.
		if( map.markers.length == 1 ){
			map.setCenter( bounds.getCenter() );

		// Case: Multiple markers.
		} else{
			map.fitBounds( bounds );
		}
	}

	// Render maps on page load.
	$(document).ready(function(){
		$('.acf-map').each(function(){
			var map = initMap( $(this) );
		});
	});


});
} )( jQuery );